module.exports = __webpack_public_path__ + "static/media/dashboard.6277d56a.svg";